module.exports = __webpack_public_path__ + "static/img/Activities_500px.c603c81.png";